'use client'

import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { ReactNode } from 'react'

import CustomersHero from '@/components/Hero/CustomersHero'
import LearnMoreTiles from '@/components/LearnMoreTiles'
import RequestDemo from '@/components/RequestDemo'
import CaseStudySummary from '@/sections/CaseStudySummary'
import CustomersTab1 from '@/sections/CustomersTab1'
import CustomersTab2 from '@/sections/CustomersTab2'
import CustomersTab3 from '@/sections/CustomersTab3'
import FortoCaseStudyBox from '@/sections/FortoCaseStudyBox'
import HomepageLogos from '@/sections/HomepageLogos'
import LogixboardCaseStudyBox from '@/sections/LogixboardCaseStudyBox'
import PayhawkCaseStudyBox from '@/sections/PayhawkCaseStudyBox'
import { RenderOn } from '@/utills/DeviceUtils'

function Heading({ text }: { text: ReactNode }) {
    return (
        <>
            <RenderOn breakPoints={['md', 'lg', 'xl']}>
                <Text
                    sx={{
                        mb: 15,
                        textAlign: 'center',
                    }}
                    variant={`h4`}
                >
                    {text}
                </Text>
            </RenderOn>
            <RenderOn breakPoints={['xs', 'sm']}>
                <Text
                    sx={{
                        mb: 6,
                        textAlign: 'start',
                    }}
                    variant={`h5`}
                >
                    {' '}
                    {text}
                </Text>
            </RenderOn>
        </>
    )
}

export default function Customers() {
    return (
        <>
            <Box>
                <CustomersHero />
                <HomepageLogos />
            </Box>
            <CaseStudySummary />
            <LearnMoreTiles
                tiles={[
                    {
                        title: <>Logistics</>,
                        scrollToSection: 'logistics-section',
                        icon: '/icons/icon-logistics.png',
                    },
                    {
                        title: 'Spend management',
                        scrollToSection: 'spend-management-section',
                        icon: '/icons/icon-fintech.png',
                    },
                    {
                        title: <>Carbon credits buyers</>,
                        scrollToSection: 'funding-climate-projects',
                        icon: '/icons/icon-climate-projects.png',
                    },
                ]}
            />
            <FortoCaseStudyBox />
            <Box id={`logistics-section`}>
                <Heading
                    text={
                        <>
                            Meeting growing demand <br />
                            for emissions tracking in logistics
                        </>
                    }
                />
                <CustomersTab2 />
            </Box>
            <LogixboardCaseStudyBox />
            <Box id={`spend-management-section`}>
                <Heading
                    text={
                        <>
                            Standing out using AI-powered
                            <br />
                            emissions intelligence
                        </>
                    }
                />
                <CustomersTab3 />
            </Box>
            <PayhawkCaseStudyBox />
            <Box id={`funding-climate-projects`}>
                <Heading
                    text={
                        <>
                            Funding climate projects that deliver <br />
                            measurable impact and peace of mind
                        </>
                    }
                />
                <CustomersTab1 />
            </Box>
            <RequestDemo />
        </>
    )
}
